export default __webpack_public_path__ + "static/media/baseball-player-copynew.d6b20b38.png";